import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, catchError, map } from 'rxjs';

import { costRequestModel, costResponseModel } from '../../organization/models/costs';
import { apiEndpoints } from 'src/app/shared/enums/api-endpoints';
@Injectable({
  providedIn: 'root'
})
export class ExpensesService {

  constructor(
    private httpClient: HttpClient
  ) { }

  costList(page: number, limit: number, search_value:any): Observable<costResponseModel> {
    return this.httpClient.get<costResponseModel>(apiEndpoints.cost + `?page=${page}&limit=${limit}&search_value=${search_value}`).pipe(
      map((response: costResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getCostDetails(cost_id: any): Observable<costResponseModel> {
    return this.httpClient.get<costResponseModel>(apiEndpoints.cost + cost_id + '/').pipe(
      map((response: costResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  createCost(addCostRequest: costRequestModel): Observable<costResponseModel> {
    return this.httpClient.post<costResponseModel>(apiEndpoints.cost, addCostRequest).pipe(
      map((response: costResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updateCost(updatedCost: costRequestModel, cost_id: string): Observable<costResponseModel> {
    return this.httpClient.put<costResponseModel>(apiEndpoints.cost + cost_id + '/', updatedCost).pipe(
      map((response: costResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  deleteCost(costId: string, data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.cost + costId + '/', data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  multipleDeleteExpense(costs:any):Observable<any>{
    return this.httpClient.patch<any>(apiEndpoints.multiple_cost_delete, costs).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

}